export default __webpack_public_path__ + "static/Wijaya Andre-88ef6cc45b63d021d32e524f531ba58e.jpeg";